<template>
  <CRow>
    <CCol sm="12" xs="12" md="12" lg="12" xl="12" class="text-center"> </CCol>
    <CCol sm="12" xs="12" md="3" lg="3" xl="3">
      <CCard>
        <header class="card-header w-100">
          <b>CLIENTES DEL D&Iacute;A</b>
          <button
            @click="mtdBack"
            type="button"
            class="btn btn-sm text-white float-right"
            style="background: #e46666"
          >
            <i class="fas fa-hand-point-left"></i> Ir a Inicio
          </button>
        </header>
      </CCard>
      <CCard
        v-for="(item, index) in level"
        :key="index"
        @click="mtdSelectLevel(index)"
        :class="mtdGetClassCommand(index)"
      >
        <CCardHeader class="text-center text-uppercase font-weight-bold">
          {{ item.name }}
        </CCardHeader>
      </CCard>
    </CCol>
    <CCol sm="12" xs="12" md="9" lg="9" xl="9" v-if="posSelectLevel >= 0">
      <CCard>
        <CCardBody id="area-canva">
          <div
            class="position-relative border rounded bg-light"
            style="width: 100%; height: 500px; overflow: hidden"
          >
            <button
              v-for="(mesa, index) in level[posSelectLevel].detalle.filter(
                (m) => m.position
              )"
              :key="index"
              type="button"
              :class="mtdGetStayteAtention(mesa.state_attention)"
              :style="{
                top: mesa.y + 'px',
                left: mesa.x + 'px',
                padding: '0.5rem',
                fontSize: '0.9rem',
                height: '60px',
                width: '120px',
              }"
              @click="mtdSelectTable(index)"
            >
              <i class="fas fa-table"></i> {{ mesa.name }}
            </button>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <!-- component full -->
    <cModalFullComand v-model="modalFull.showModal">
      <template #header>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; flex-grow: 1;">
          <h5 class="modal-title" style="margin: 0;">{{ modalFull.title }}</h5>
        </div>
      </template>

      <div style="min-height: 500px">
        <CRow>
          <CCol xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
            <CRow>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                class="text-center"
                ><h3>
                  TOTAL: S/. <b>{{ cpTotalComand }}</b>
                </h3></CCol
              >
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                class="text-left"
                v-if="command.length > 0"
              >
                <CButton
                  v-for="(item, pos) in command"
                  :key="pos"
                  class="w-100"
                  block
                  variant="outline"
                  :color="mtdGetClassItemCommand(item.state)"
                  @click="mtdSelectItemComand(item, pos)"
                >
                  <b
                    ><i v-if="item.status == 3" class="fas fa-ban"></i> ({{
                      item.quantity
                    }}) {{ item.name }} | {{ item.price_key }}</b
                  >
                  <br />
                  <span>{{ mtdGetStateItemCommand(item.state) }}</span>
                  <br />
                  <small v-if="item.created_at" style="color: #666; font-size: 0.85rem;">
                    <i class="fas fa-clock"></i> {{ mtdFormatDateTime(item.created_at) }}
                  </small>
                  <br v-if="item.created_at" />
                  {{ item.anotation }}
                </CButton>
              </CCol>
              <CCol v-else xs="12" sm="12" md="12" lg="12" xl="12" xxl="12"
                ><h5>aun no tiene pedidos!!!</h5></CCol
              >
            </CRow>
          </CCol>
          <CCol xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
            <CRow>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                class="text-center"
                ><h5>PLATOS DISPONIBLES</h5></CCol
              >
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                class="text-center"
                v-if="product.length > 0"
              >
                <button
                  v-for="category in product"
                  :key="category.id"
                  class="btn btn-outline-primary ml-2"
                  :class="{
                    active:
                      selectedCategory && selectedCategory.id == category.id,
                  }"
                  @click="mtdSelectCategory(category)"
                >
                  {{ category.name }}
                </button>
              </CCol>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                class="mt-3"
                v-if="selectedCategory"
              >
                <CInput
                  type="text"
                  placeholder="Buscar producto.."
                  v-model="search"
                ></CInput>
              </CCol>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                v-if="selectedCategory"
              >
                <CButton
                  v-for="(item, index) in cpFilteredProducts"
                  :key="index"
                  class="mr-2 mt-1 btn btn-lg btn-info"
                  @click="mtdAddItemCommand(item)"
                >
                  <b>{{ item.name }}</b>
                </CButton>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <button class="btn btn-secondary" v-if="command.length==0" @click="mtdFreeTable">
          <i class="fas fa-folder-open"></i> Liberar mesa
        </button>
        <button class="btn btn-success" @click="mtdViewComands">
          <i class="fas fa-eye"></i> Ver comandas
        </button>
        <button class="btn btn-warning" @click="mtdMoveProducts">
          <i class="fas fa-exchange-alt"></i> Mover Productos
        </button>
        <button class="btn btn-primary" @click="mtdChangeTable">
          <i class="fas fa-recycle"></i> Cambiar de mesa
        </button>
        <button class="btn btn-info" @click="mtdPreview">
          <i class="fas fa-table"></i> Vista Previa
        </button>
        <button class="btn btn-danger" @click="mtdCloseModal">
          <i class="fas fa-times"></i> Salir
        </button>
      </template>
    </cModalFullComand>
  </CRow>
</template>

<script>
import { mapActions } from "vuex";
import cModalFullComand from "./modals/cModalFullComand.vue";

export default {
  name: "mozo-home-drop",
  components: { cModalFullComand },
  data() {
    return {
      prefix: "mozo",
      level: [],
      posSelectLevel: -1,
      posSelectTable: -1,
      command: [],
      product: [],
      // dataShowProduct: [],
      search: "",
      sale_id: 0,
      modalFull: {
        title: "",
        showModal: false,
      },
      selectedCategory: null,
      /** new command */
      step: 0,
      newCommand: [],
      pdfUrl: null,
      /*** change table*/
      freetable: [],
    };
  },
  created() {
    this.mtdGetData();
  },
  computed: {
    cpFilteredProducts() {
      if (!this.selectedCategory) return [];

      const search = this.search.toLowerCase();

      return this.selectedCategory.detail.filter((product) =>
        product.name.toLowerCase().includes(search)
      );
    },
    cpTotalComand() {
      let total = 0;
      this.command.forEach((element) => {
        total += parseFloat(element.quantity * element.price);
      });
      return parseFloat(total).toFixed(2);
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack() {
      this.$emit("setView", "home");
    },
    mtdGetData: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.level = response.data.level;
          this.product = response.data.products;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdSelectLevel: function (pos) {
      (this.posSelectTable = -1), (this.posSelectLevel = pos);
    },
    mtdGetStayteAtention: function (status) {
      const state = Number(status);
      let res = "";
      switch (state) {
        case 1:
          res = "btn btn-success position-absolute text-center";
          break;
        case 2:
          res = "btn btn-danger position-absolute text-center";
          break;
        case 3:
          res = "btn btn-warning position-absolute text-center";
          break;
        default:
          break;
      }
      return res;
    },
    mtdSelectTable: function (pos) {
      this.posSelectTable = pos;
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/getcomand/" +
          this.level[this.posSelectLevel].detalle[this.posSelectTable].id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.command = response.data.comand;
          this.sale_id = response.data.sale;
          this.modalFull.showModal = true;
          this.modalFull.title =
            "Comandas de: " +
            this.level[this.posSelectLevel].detalle[this.posSelectTable].name;
          this.newCommand = [];
          this.step = response.data.step;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdGetClassCommand: function (pos) {
      if (pos == this.posSelectLevel) {
        return "bg-info text-white";
      }
    },
    mtdSelectCategory(category) {
      this.selectedCategory = category;
      this.search = "";
    },
    mtdAddItemCommand: function (payload) {
      let quantity = "";
      let anotation = "";
      // Convierte a un array y filtra solo precios > 0
      const preciosFiltrados = Object.entries(payload.prices)
        .filter(([_, valor]) => parseFloat(valor) > 0)
        .map(([key, valor]) => ({
          label: key.replace("sale_", "").toUpperCase(), // familiar, grande, etc.
          value: parseFloat(valor),
        }));
      Swal.fire({
        title: "Cantidad y Detalle",
        html: `
          <input id="input-quantity" class="swal2-input" placeholder="Cantidad" value="${quantity}">
          <input id="input-detail" class="swal2-input" placeholder="Detalle (opcional)" value="${anotation}">
          <div id="price-buttons" style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: center; margin-top: 10px;">
            ${preciosFiltrados
              .map(
                (p) => `
                <button
                  type="button"
                  class="btn-precio"
                  data-precio="${p.value}"
                  data-key="${p.label}"
                  style="
                    padding: 8px 14px;
                    border: none;
                    background-color: #e0e0e0;
                    color: #333;
                    border-radius: 6px;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    transition: background-color 0.2s, transform 0.1s;
                  "
                >
                  ${p.label}: S/ ${p.value.toFixed(2)}
                </button>`
              )
              .join("")}
          </div>
          <input type="hidden" id="input-price">
          <input type="hidden" id="input-price-key">`,
        icon: "info",
        showCancelButton: true,
        didOpen: () => {
          const buttons = document.querySelectorAll(".btn-precio");
          buttons.forEach((btn) => {
            btn.addEventListener("click", () => {
              buttons.forEach((b) => {
                b.style.backgroundColor = "#e0e0e0";
                b.style.color = "#333";
                b.style.transform = "none";
              });

              btn.style.backgroundColor = "#3085d6";
              btn.style.color = "#fff";
              btn.style.transform = "scale(1.05)";
              document.getElementById("input-price").value =
                btn.getAttribute("data-precio");
              document.getElementById("input-price-key").value =
                btn.getAttribute("data-key");
            });
          });
        },
        preConfirm: () => {
          const quantity =
            document.getElementById("input-quantity")?.value || "";
          const detail = document.getElementById("input-detail")?.value || "";
          const price = document.getElementById("input-price")?.value || "";
          const priceKey =
            document.getElementById("input-price-key")?.value || "";

          if (!quantity || !price || !priceKey) {
            Swal.showValidationMessage("Cantidad y precio son obligatorios");
            return null;
          }

          return { quantity, detail, price, priceKey };
        },
      }).then((inputResult) => {
        if (inputResult.isConfirmed && inputResult.value) {
          const { quantity, detail, price, priceKey } = inputResult.value;
          const now = new Date();
          let itemComand = {
            id: payload.id,
            name: payload.name,
            anotation: detail || "",
            quantity,
            price,
            price_key: priceKey,
            type: payload.type, // 1: plato 2: prd
            state: 1, // pendiente 2: entregado
            created_at: now.toISOString(), // Agregar fecha/hora actual inmediatamente
          };
          this.command.push(itemComand);
          this.mtdSetItemCommand(itemComand);
        }
      });
    },
    mtdSetItemCommand: function (itemComand) {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/setitemcomand/" +
          this.level[this.posSelectLevel].detalle[this.posSelectTable].id,
        params: {
          sale_id: this.sale_id,
          item: itemComand,
          step: this.step,
          campu_id : this.$store.getters.get_campu.id
        },
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.sale_id = response.data.sale;
          this.level[this.posSelectLevel].detalle[
            this.posSelectTable
          ].state_attention = response.data.state_table;
          
          const lastIndex = this.command.length - 1;
          if (lastIndex >= 0 && response.data.detail) {
            this.command[lastIndex].idDet = response.data.detail.id;
            this.command[lastIndex].step = response.data.detail.step;
            this.command[lastIndex].status = response.data.detail.state;
            // Actualizar con la fecha del servidor (más precisa), o mantener la fecha local si no viene
            if (response.data.detail.created_at) {
              this.command[lastIndex].created_at = response.data.detail.created_at;
            }
          }
          
          this.newCommand.push(response.data.detail);
          Swal.fire({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 3000,
            icon: "success",
            title: "Item agregado correctamente!",
            text: "Puedes continuar",
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdGetClassItemCommand: function (state) {
      const parseState = parseInt(state);
      let resClas = "";
      switch (parseState) {
        case 1:
          resClas = "danger";
          break;
        case 2:
          resClas = "warning";
          break;
        case 3:
          resClas = "success";
          break;
        default:
          break;
      }
      return resClas;
    },
    mtdGetStateItemCommand: function (state) {
      const parseState = parseInt(state);
      let resText = "";
      switch (parseState) {
        case 1:
          resText = "Pendiente";
          break;
        case 2:
          resText = "Preparando";
          break;
        case 3:
          resText = "Entregado";
          break;
        default:
          break;
      }
      return resText;
    },
    mtdFormatDateTime: function (dateTime) {
      if (!dateTime) return "";
      const date = new Date(dateTime);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // Si es 0, mostrar 12
      const hoursStr = String(hours).padStart(2, "0");
      return `${day}/${month}/${year} ${hoursStr}:${minutes} ${ampm}`;
    },
    mtdSelectItemComand: function (payload, pos) {
      if (payload.status != 3) {
        let quantity = payload.quantity;
        let anotation = payload.anotation ? payload.anotation : "";
        
        // Verificar si es bebida pendiente
        const isBeverage = payload.is_beverage && payload.state == 1;
        
        // HTML del modal
        let modalHtml = `
          <input id="input-quantity" class="swal2-input" placeholder="Cantidad" value="${quantity}">
          <input id="input-detail" class="swal2-input" placeholder="Detalle (opcional)" value="${anotation}">`;
        
        // Si es bebida pendiente, agregar botón de entregar
        if (isBeverage) {
          modalHtml += `
            <div style="margin-top: 15px; text-align: center;">
              <button
                id="btn-entregar-bebida"
                type="button"
                style="
                  padding: 10px 20px;
                  background-color: #28a745;
                  color: white;
                  border: none;
                  border-radius: 6px;
                  cursor: pointer;
                  font-weight: bold;
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                "
              >
                <i class="fas fa-check"></i> ENTREGAR BEBIDA
              </button>
            </div>`;
        }
        
        Swal.fire({
          showClass: {
            popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `,
          },
          hideClass: {
            popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `,
          },
          title: "Cantidad y Detalle",
          html: modalHtml,
          icon: "info",
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: "Guardar",
          cancelButtonText: "Cancelar",
          denyButtonText: "Eliminar",
          didOpen: () => {
            // Event listener para el botón de entregar bebida (solo si es bebida pendiente)
            const btnEntregar = document.getElementById("btn-entregar-bebida");
            if (btnEntregar) {
              btnEntregar.addEventListener("click", () => {
                this.mtdDeliverBeverage(payload, pos);
              });
            }
          },
          preConfirm: () => {
            const quantity =
              document.getElementById("input-quantity")?.value || "";
            const detail = document.getElementById("input-detail")?.value || "";

            if (!quantity) {
              Swal.showValidationMessage("Cantidad es obligatorio");
              return null;
            }

            return { quantity, detail };
          },
        }).then((inputResult) => {
          if (inputResult.isConfirmed && inputResult.value) {
            const { quantity, detail } = inputResult.value;
            let itemUpComand = {
              id: payload.id,
              idDet: payload.idDet,
              idSale: this.sale_id,
              anotation: detail || "",
              quantity,
            };
            this.mtdUpItemCommand(itemUpComand, pos);
          } else if (inputResult.isDenied) {
            // Acción cuando se elimina
            let itemDeleteCommand = {
              idDet: payload.idDet,
              idSale: this.sale_id,
            };
            this.mtdDeleteItemCommand(itemDeleteCommand, pos);
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
          icon: "warning",
          title: "A la espera de aprobación de eliminación!",
          text: "",
        });
      }
    },
    mtdUpItemCommand: function (payload, pos) {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/upitemcomand",
        params: payload,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.command[pos].quantity = payload.quantity;
            this.command[pos].anotation = payload.anotation;
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "Item editado correctamente!",
              text: "Puedes continuar",
            });
          } else {
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "ups!! Algo salió mal!!",
              text: response.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdDeleteItemCommand: function (payload, pos) {
      this.post({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/delitemcomand",
        params: payload,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.data.booPermiso == 0) {
              Swal.fire({
                toast: true,
                position: "center",
                showConfirmButton: false,
                timer: 3000,
                icon: "success",
                title: "Item borrado correctamente!",
                text: "Puedes continuar",
              });
              this.command.splice(pos, 1);
              
              // Imprimir ticket de cancelación
              if (response.data.idDet) {
                // Guardar ID antes de eliminar del array
                const saleDetailId = response.data.idDet;
                setTimeout(() => {
                  window.open(
                    `${this.$store.getters.get__url}/mozo/printcanceledproduct/${saleDetailId}`,
                    "_blank"
                  );
                }, 100);
              }
            } else {
              Swal.fire({
                toast: true,
                position: "center",
                showConfirmButton: false,
                timer: 3000,
                icon: "warning",
                title: "Solicitud registrada correctamente!",
                text: "Debe esperar a que se acepte.",
              });
              // Imprimir ticket de cancelación aunque esté pendiente
              if (response.data.idDet) {
                const saleDetailId = response.data.idDet;
                setTimeout(() => {
                  this.command[pos].status = 3;
                  window.open(
                    `${this.$store.getters.get__url}/mozo/printcanceledproduct/${saleDetailId}`,
                    "_blank"
                  );
                }, 100);
              }
            }
          } else {
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "ups!! Algo salió mal!!",
              text: response.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdCloseModal: function () {
      this.modalFull.showModal = false;
      if (this.newCommand.length > 0) {
        const idTable =
          this.level[this.posSelectLevel].detalle[this.posSelectTable].id;
        const ids = this.newCommand.map((item) => item.id).join(",");
        window.open(
          `${this.$store.getters.get__url}/${this.prefix}/commandnew/${idTable}/${ids}`,
          "_blank"
        );
      }
    },
    mtdPreview: function () {
      const idTable =
        this.level[this.posSelectLevel].detalle[this.posSelectTable].id;
      window.open(
        `${this.$store.getters.get__url}/${this.prefix}/commandPreview/${idTable}/${this.sale_id}`,
        "_blank"
      );
    },
    /** cambio de mesa */
    mtdChangeTable: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/getfreetable/" +
          this.level[this.posSelectLevel].detalle[this.posSelectTable].id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.freetable = response.data;
          let selectedId = null;
          Swal.fire({
            title: "Selecciona una mesa",
            html: this.freetable
              .map(
                (item) =>
                  `<button 
                id="btn-${item.id}" 
                class="swal2-confirm swal2-styled mesa-btn" 
                style="margin:5px; background:#3085d6"
                data-id="${item.id}">
                ${item.name}
              </button>`
              )
              .join(""),
            showConfirmButton: true,
            confirmButtonText: "Confirmar",
            didOpen: () => {
              // agregar listeners a los botones de mesa
              const buttons =
                Swal.getHtmlContainer().querySelectorAll(".mesa-btn");
              buttons.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                  // resetear estilos
                  buttons.forEach((b) => (b.style.background = "#3085d6"));
                  // marcar el seleccionado
                  e.target.style.background = "#28a745";
                  selectedId = e.target.dataset.id;
                });
              });
            },
            preConfirm: () => {
              if (!selectedId) {
                Swal.showValidationMessage(
                  "Debes seleccionar una mesa primero"
                );
                return false;
              }
              return selectedId;
            },
          }).then((result) => {
            if (result.isConfirmed) {
              this.post({
                url:
                  this.$store.getters.get__url +
                  "/" +
                  this.prefix +
                  "/chagetable",
                params: {
                  new: result.value,
                  old: this.level[this.posSelectLevel].detalle[
                    this.posSelectTable
                  ].id,
                  sale: this.sale_id,
                },
                token: this.$store.getters.get__token,
              })
                .then((response) => {
                  if (response.statusCode == 200) {
                    this.mtdGetData();
                    this.modalFull.showModal = false;
                    Swal.fire({
                      toast: true,
                      position: "center",
                      showConfirmButton: false,
                      timer: 3000,
                      icon: "success",
                      title: "Correcto!!",
                      text: response.message,
                    });
                  } else {
                    Swal.fire({
                      toast: true,
                      position: "center",
                      showConfirmButton: false,
                      timer: 3000,
                      icon: "error",
                      title: "ups!! Algo salió mal!!",
                      text: response.message,
                    });
                  }
                })
                .catch((errors) => {
                  console.log(errors);
                });
            }
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    /*** view commands */
    mtdViewComands: function () {
      const grouped = Object.values(
        this.command.reduce((acc, item) => {
          if (!acc[item.step]) {
            acc[item.step] = { step: item.step, detail: [] };
          }
          acc[item.step].detail.push(item);
          return acc;
        }, {})
      );
      const ordered = grouped.sort((a, b) => a.step - b.step);
      const html = grouped
        .map((group) => {
          const items = group.detail
            .map((d) => `<li>${d.name} — ${d.quantity} x S/ ${d.price}</li>`)
            .join("");
          return `
      <div style="margin-bottom:12px;text-align:left;display:flex;justify-content:space-between;align-items:center;">
        <div>
          <h4 style="margin:0;">Comanda ${group.step}</h4>
          <ul style="margin:0 0 0 15px;">${items}</ul>
        </div>
        <button class="swal2-step-btn" data-step="${group.step}" style="background:#3085d6;color:#fff;border:none;padding:6px 12px;border-radius:5px;cursor:pointer;">
          Ver Comanda
        </button>
      </div>
    `;
        })
        .join("");

      Swal.fire({
        title: "",
        html,
        icon: "info",
        confirmButtonText: "Cerrar",
        width: 650,
        didOpen: () => {
          // 4️⃣ Asignar eventos a los botones
          document.querySelectorAll(".swal2-step-btn").forEach((btn) => {
            btn.addEventListener("click", (e) => {
              const step = Number(e.target.getAttribute("data-step"));
              const group = grouped.find((g) => g.step == step);
              const ids = group.detail.map((item) => item.idDet).join(",");
              const idTable =
                this.level[this.posSelectLevel].detalle[this.posSelectTable].id;
              window.open(
                `${this.$store.getters.get__url}/${this.prefix}/commandnew/${idTable}/${ids}`,
                "_blank"
              );
            });
          });
        },
      });
    },
    
    // Método para entregar bebida desde el modal
    mtdDeliverBeverage: function(payload, pos) {
      Swal.fire({
        title: '¿Entregar bebida?',
        text: `¿Confirmar entrega de ${payload.name}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, entregar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.post({
            url: this.$store.getters.get__url + "/" + this.prefix + "/deliverbeverage",
            params: {
              idDet: payload.idDet
            },
            token: this.$store.getters.get__token,
          })
          .then((response) => {
            // Actualizar el estado del item en la vista
            this.command[pos].state = 3;
            // Cerrar el modal actual
            Swal.close();
            // Mostrar mensaje de éxito
            Swal.fire({
              title: '¡Entregado!',
              text: 'La bebida ha sido marcada como entregada',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            });
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error',
              text: error.response?.data?.data?.error_message || 'Error al entregar la bebida',
              icon: 'error'
            });
          });
        }
      });
    },
    
    /** Mover productos entre mesas */
    mtdMoveProducts: function() {
      // Filtrar solo productos que no estén eliminados
      const availableProducts = this.command.filter(item => item.status != 3);
      
      if (availableProducts.length == 0) {
        Swal.fire({
          title: 'Sin productos',
          text: 'No hay productos disponibles para mover',
          icon: 'warning'
        });
        return;
      }
      
      // Paso 1: Seleccionar productos a mover
      const checkboxesHtml = availableProducts
        .map((item, index) => {
          const stateText = item.state == 1 ? 'Pendiente' : item.state == 2 ? 'Preparando' : 'Entregado';
          const stateColor = item.state == 1 ? '#dc3545' : item.state == 2 ? '#ffc107' : '#28a745';
          return `
            <div style="margin: 8px 0; text-align: left; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
              <label style="display: flex; align-items: center; cursor: pointer;">
                <input type="checkbox" class="product-checkbox" data-index="${index}" data-id="${item.idDet}" 
                  style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;">
                <div style="flex: 1;">
                  <strong>(${item.quantity}) ${item.name} - ${item.price_key}</strong><br>
                  <small style="color: ${stateColor};">Estado: ${stateText}</small><br>
                  <small>${item.anotation || ''}</small>
                </div>
              </label>
            </div>
          `;
        })
        .join('');
      
      Swal.fire({
        title: 'Seleccionar productos a mover',
        html: `
          <div style="max-height: 400px; overflow-y: auto; text-align: left;">
            ${checkboxesHtml}
          </div>
        `,
        width: 600,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          const checkboxes = document.querySelectorAll('.product-checkbox:checked');
          const selectedIds = Array.from(checkboxes).map(cb => cb.getAttribute('data-id'));
          
          if (selectedIds.length == 0) {
            Swal.showValidationMessage('Debes seleccionar al menos un producto');
            return null;
          }
          
          return selectedIds;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          // Paso 2: Obtener mesas disponibles y seleccionar destino
          this.mtdSelectTargetTable(result.value);
        }
      });
    },
    
    mtdSelectTargetTable: function(selectedProductIds) {
      // Obtener la mesa actual
      const currentTableId = this.level[this.posSelectLevel].detalle[this.posSelectTable].id;
      
      // Obtener todas las mesas de todos los pisos, agrupadas por piso
      const floorTablesHtml = this.level
        .map((floor, floorIndex) => {
          // Filtrar mesas del piso actual excluyendo la mesa origen
          const floorTables = floor.detalle.filter(table => table.id != currentTableId);
          
          if (floorTables.length == 0) {
            return ''; // No mostrar pisos sin mesas disponibles
          }
          
          const tablesButtons = floorTables
            .map(table => {
              const statusText = table.state_attention == 1 ? 'Libre' : 'Ocupada';
              const bgColor = table.state_attention == 1 ? '#28a745' : '#dc3545';
              return `
                <button 
                  class="mesa-btn-select" 
                  data-id="${table.id}" 
                  style="
                    margin: 5px; 
                    padding: 10px 20px;
                    background-color: ${bgColor};
                    color: white;
                    border: none;
                    border-radius: 6px;
                    cursor: pointer;
                    font-weight: bold;
                    transition: all 0.2s;
                  ">
                  ${table.name} <br><small>(${statusText})</small>
                </button>
              `;
            })
            .join('');
          
          return `
            <div style="margin-bottom: 20px; padding: 10px; background: #f8f9fa; border-radius: 8px;">
              <h6 style="margin: 0 0 10px 0; color: #495057; font-weight: bold;">
                <i class="fas fa-layer-group"></i> ${floor.name}
              </h6>
              <div style="text-align: center;">
                ${tablesButtons}
              </div>
            </div>
          `;
        })
        .filter(html => html != '') // Eliminar pisos sin mesas
        .join('');
      
      if (!floorTablesHtml) {
        Swal.fire({
          title: 'Sin mesas disponibles',
          text: 'No hay otras mesas disponibles',
          icon: 'warning'
        });
        return;
      }
      
      let selectedTableId = null;
      
      Swal.fire({
        title: 'Seleccionar mesa destino',
        html: `
          <div style="max-height: 500px; overflow-y: auto;">
            <p style="margin-bottom: 15px;">
              <i class="fas fa-circle" style="color: #28a745;"></i> Libre 
              <i class="fas fa-circle ml-3" style="color: #dc3545;"></i> Ocupada
            </p>
            ${floorTablesHtml}
          </div>
        `,
        width: 700,
        showCancelButton: true,
        confirmButtonText: 'Mover productos',
        cancelButtonText: 'Cancelar',
        didOpen: () => {
          const buttons = document.querySelectorAll('.mesa-btn-select');
          buttons.forEach(btn => {
            btn.addEventListener('click', (e) => {
              buttons.forEach(b => b.style.boxShadow = 'none');
              e.currentTarget.style.boxShadow = '0 0 0 4px #ffffff, 0 0 0 6px #0056b3';
              selectedTableId = e.currentTarget.getAttribute('data-id');
            });
          });
        },
        preConfirm: () => {
          if (!selectedTableId) {
            Swal.showValidationMessage('Debes seleccionar una mesa destino');
            return null;
          }
          return selectedTableId;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          // Paso 3: Confirmar y ejecutar el movimiento
          this.mtdExecuteMoveProducts(selectedProductIds, result.value);
        }
      });
    },
    
    mtdExecuteMoveProducts: function(productDetailsIds, targetTableId) {
      const sourceTableId = this.level[this.posSelectLevel].detalle[this.posSelectTable].id;
      
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/moveproducts",
        params: {
          product_details_ids: productDetailsIds,
          source_table_id: sourceTableId,
          target_table_id: targetTableId
        },
        token: this.$store.getters.get__token,
      })
      .then((response) => {
        if (response.statusCode == 200) {
          const movedCount = response.data.products_moved;
          const sourceEmpty = response.data.source_sale_empty;
          
          Swal.fire({
            title: '¡Productos movidos!',
            html: `
              Se movieron ${movedCount} producto(s) exitosamente.<br>
              ${sourceEmpty ? '<strong>La mesa origen fue liberada (quedó vacía)</strong>' : ''}
            `,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false
          });
          
          // Recargar datos y cerrar modal
          this.mtdGetData();
          this.modalFull.showModal = false;
        }
      })
      .catch((error) => {
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.data?.error_message || 'Error al mover productos',
          icon: 'error'
        });
      });
    },
    mtdFreeTable: function(){
      console.log();
      Swal.fire({
        title: 'Liberar Mesa',
        text: `¿Confirmar liberación de mesa?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, liberar',
        cancelButtonText: 'No,Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.get({
            url: this.$store.getters.get__url + "/" + this.prefix + "/freetable/"+this.level[this.posSelectLevel].detalle[this.posSelectTable].id,
            token: this.$store.getters.get__token,
          })
          .then((response) => {
            //this.level[this.posSelectLevel].detalle[this.posSelectTable].state = 1;
            Swal.close();
            // Mostrar mensaje de éxito
            Swal.fire({
              title: '¡Entregado!',
              text: 'La mesa ha sido liberada correctamente',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            });
            this.mtdCloseModal();
            this.mtdGetData();
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error',
              text: error.response?.data?.data?.error_message || 'Error al liberar',
              icon: 'error'
            });
          });
        }
      });
    }
  },
};
</script>
